<div class="row row-item p-3" [ngClass]="{'active' : active}">
  <div class="col p-0 d-flex align-items-center row-body" [ngClass]="{'col-disabled':disabled }" (click)="onRowClick()">
    <div class="d-flex align-items-center" >
      <ng-content select="[prepend]"></ng-content>
      <div class="p-0">
        <div class="row-title">{{title}}<span class="span-title">{{spanTitle}}</span></div>
        @if (child?.type == NodeType.FILE && updatedAt) {
          <div class="row-subtitle">
            Déposé le {{createdAt | date : 'dd/MM/yy'}}
          </div>
        }
        @if (child?.type == NodeType.FOLDER) {
          <div class="row-subtitle">
            {{ countFilesFolder(child) }}
          </div>
        }
        <div class="row-subtitle">{{subtitle}}</div>
        <div class="row-second-subtitle">{{secondSubtitle}}</div>
      </div>
    </div>
    <ng-content select="[append]"></ng-content>
  </div>
  <div class="col-1 p-0 justify-content-end" [ngClass]="{'d-none' : !hasActions}">
    <div ngbDropdown [placement]="placement">
      <button type="button" class="btn btn-circle btn-light float-end" ngbDropdownToggle>
        <fa-icon [icon]="faEllipsisV"></fa-icon>
      </button>
      <div ngbDropdownMenu #actionsWrapper>
        <ng-content select="[actions]"></ng-content>
      </div>
    </div>
  </div>
</div>
